function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M30 .09C46.52.09 59.91 13.48 59.91 30S46.52 59.91 30 59.91.09 46.52.09 30 13.48.09 30 .09zm0 2.678C14.96 2.768 2.768 14.96 2.768 30S14.96 57.232 30 57.232 57.232 45.04 57.232 30 45.04 2.768 30 2.768zm13.1 14.447c.493.493.522 1.273.087 1.799l-.087.095-11.048 11.049L42.72 40.826c.523.523.523 1.371 0 1.894-.492.493-1.272.522-1.798.087l-.096-.087-10.669-10.669-11.048 11.05c-.523.522-1.37.522-1.894 0-.523-.524-.523-1.372 0-1.895l11.048-11.049L17.28 19.174c-.523-.523-.523-1.371 0-1.894.492-.493 1.272-.522 1.798-.087l.096.087 10.984 10.984 11.048-11.049c.523-.523 1.371-.523 1.894 0z",
  transform: "translate(-150 -157) translate(29 115) translate(121 42)"
}));

var SvgCloseCircleIcon = function SvgCloseCircleIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: props.color,
    fillRule: "nonzero"
  }, _ref2)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseCircleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close_circle_icon.8eae71d8.svg";
export { ForwardRef as ReactComponent };